import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import styles from './NotFound.module.css';

export default function NotFound() {
  usePageMeta('Page not found — Revive Worship');

  return (
    <section className={styles.section}>
      <div className={styles.shell}>
        <span className={styles.eyebrow}>404</span>
        <h1 className={styles.title}>
          This page <em>wandered off.</em>
        </h1>
        <p className={styles.script} aria-hidden="true">but you're welcome here</p>
        <p className={styles.lede}>
          The address you followed doesn't exist anymore, or never did.
          Worship still does.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={`${styles.btn} ${styles.btnSolid}`}>
            Back home <span aria-hidden="true">→</span>
          </Link>
          <Link to="/nights" className={styles.btn}>
            Revive Nights <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
